import { REDUCER } from '../reducers/reducersConst';
import { RABBIT_CONNECTION } from '../const';

let defaultConnection = {
  status: {
    network: true,
    backend: true,
    rabbit: true,
    general: true,
    online: window.navigator.onLine
  },
  statusRabbitState: RABBIT_CONNECTION.KO,
  trying: false,
  attempts: 0,
  isLoadingData: false
};
export let connection = (state = defaultConnection, action) => {
  switch (action.type) {
    case REDUCER.CONNECTION.STATUS:
      return {
        ...state,
        status: {
          ...state.status,
          network: action.status.network,
          backend: action.status.backend,
          rabbit: action.status.rabbit,
          general: action.status.general,
          online: action.status.online
        }
      };
    case REDUCER.CONNECTION.STATUS_RABBIT:
      return {
        ...state,
        status: {
          ...state.status,
          rabbit: action.statusRabbit
        }
      };
    case REDUCER.CONNECTION.STATUS_RABBIT_STATE:
      return {
        ...state,
        statusRabbitState: action.statusRabbitState
      };
    case REDUCER.CONNECTION.STATUS_NETWORK:
      return {
        ...state,
        status: {
          ...state.connection,
          network: action.statusNetwork
        }
      };
    case REDUCER.CONNECTION.TRYING:
      return {
        ...state,
        trying: action.trying
      };
    case REDUCER.CONNECTION.ATTEMPTS:
      return {
        ...state,
        attempts: action.attempts
      };
    case REDUCER.CONNECTION.IS_LOADING_DATA:
      return {
        ...state,
        isLoadingData: action.isLoadingData
      };
    default:
      return state;
  }
};
